let lastWindowPos = 0;

export const scrollHandlers = {
	lock: () => {
		lastWindowPos = document.documentElement.scrollTop;
		document.body.style.top = `-${lastWindowPos}px`;
		document.body.classList.add("stopScroll");
	},
	unlock: () => {
		if (!document.body.classList.contains('stopScroll')) return

		document.body.style.top = "";
		document.body.classList.remove("stopScroll");
		document.documentElement.scrollTo({ top: Math.abs(lastWindowPos), behavior: "instant" });
	},
}